import { type LabelProps, Label as RACLabel } from 'react-aria-components';
import { cn } from '~/shared/components/utils';
import { fieldLabelStyles } from './util';

export function FieldLabel(props: LabelProps) {
	return <RACLabel {...props} className={cn(fieldLabelStyles(), props.className)} />;
}
